// extracted by mini-css-extract-plugin
module.exports = {"departments":"Gn-z","departmentHeading":"Hn-z","departmentSection":"In-z","departmentName":"Jn-z","departmentLink":"Kn-z","expandIcon":"Ln-z"};